import React from 'react'
import styles from './update-group.styles'
import injectSheet from 'react-jss'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormSelect from 'pobble-components/dist/form-elements/form-select'
import * as Yup from 'yup'
import { Formik } from 'formik'

const UpdateGroup = ({
  classes,
  opened,
  requestClose = () => null,
  initialAgeGroup,
  onSubmit,
  title,
  visibility,
  editableProps
}) => (
  <Modal isOpen={opened}>
    <ModalHeader>Update group</ModalHeader>
    <Formik
      validationSchema={Yup.object().shape({
        groupTitle: Yup.string().required(
          'Please provide a name for your group'
        )
      })}
      onSubmit={onSubmit}
      initialValues={{
        groupTitle: title,
        groupVisibility: visibility
      }}>
      {props => {
        const {
          values,
          handleChange,
          handleSubmit,
          handleBlur,
          errors,
          isValid
        } = props
        return (
          <form onSubmit={handleSubmit}>
            <ModalContent legacy className={classes.modalContent}>
              <div className={classes.row}>
                <label className={classes.label} htmlFor="groupTitle">
                  Group title
                </label>
                <FormInput
                  disabled={!editableProps.title}
                  validationError={errors.groupTitle}
                  placeholder="Enter group title"
                  id="groupTitle"
                  name="groupTitle"
                  value={values.groupTitle}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
              <div className={classes.row}>
                <label className={classes.label} htmlFor="groupTitle">
                  Visibility of the group
                </label>
                <FormSelect
                  disabled={!editableProps.visibility}
                  name="groupVisibility"
                  value={values.groupVisibility}
                  onChange={handleChange}
                  onBlur={handleBlur}>
                  <option value="public">Public</option>
                  <option value="internal">Internal</option>
                </FormSelect>
              </div>
            </ModalContent>
            <ModalFooter className={classes.footer}>
              <Button
                simple
                tall
                type="button"
                className={classes.cancel}
                action={requestClose}>
                Cancel
              </Button>
              <Button disabled={!isValid} tall type="submit">
                Update group
              </Button>
            </ModalFooter>
          </form>
        )
      }}
    </Formik>
  </Modal>
)

export default injectSheet(styles)(UpdateGroup)
